const locale = {
    VehicleVIOReport: "Vehicle VIO Report",
    ArticleVIOReport: "Article VIO Report",
    History: "History",
    UserManagement: "User Mangement",
    FirstName: "First Name",
    Email: "Email",
    Region: "Region",
    Year: "Year",
    Month: "Month",
    File: "File Type",
    DownloadDate: "Download Date",
    Type: "Type",
    Chatbot: "Chatbot"
}

export default locale;